import Play from "./containers/Play";
import EndScreen from "./containers/EndScreen";
import Privacy from "./containers/Privacy";
import InstagramShare from "./containers/InstagramShare";

export const routes = [
    {
        path: '/',
        name: 'home',
        component: Play,
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: Privacy,
        props: true
    },
    {
        path: '/end-game/insta',
        name: 'insta-share',
        component: InstagramShare,
        props: true,
    },
    {
        path: '/end-game',
        name: 'end-game',
        component: EndScreen,
        props: true,
    },
    {
        path: '/:invite',
        name: 'home.invited',
        component: Play,
        props: true,
    },
];
